import Avatar from 'components/common/Avatar'
import Flex from 'components/common/Flex'
import avatar from 'assets/img/team/avatar.png';
import React from 'react'
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AccessTile = ({ icon, label, enabled }) => {
    const isEnabled = Number(enabled) === 1;

    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip style={{ position: 'fixed' }}>{`${label}: ${isEnabled ? 'Enabled' : 'Disabled'}`}</Tooltip>}
        >
            <div
                className={`d-flex align-items-center gap-2 rounded border px-3 py-2 ${isEnabled ? 'border-success bg-success bg-opacity-10' : 'border-300 bg-200'}`}
                style={{
                    minWidth: 150
                }}
            >
                <span
                    className={`d-inline-flex align-items-center justify-content-center rounded-circle ${isEnabled ? 'text-success bg-white' : 'text-600 bg-white'}`}
                    style={{ width: 32, height: 32 }}
                >
                    <FontAwesomeIcon icon={isEnabled ? icon : 'ban'} />
                </span>
                <div>
                    <div className="fw-semibold text-900 lh-1">{label}</div>
                    <div className={`fs-11 ${isEnabled ? 'text-success' : 'text-600'}`}>
                        {isEnabled ? 'Enabled' : 'Disabled'}
                    </div>
                </div>
            </div>
        </OverlayTrigger>
    );
};

const ViewFacilityStaffProfileHeader = (props) => {
const data = props.data
const groupData = JSON.parse(localStorage.getItem("groupsData"))?.filter((value) => value.value == data.group_id)
const isFacilityStaff = Number(data?.role_id) === 5;
const hasWebAccess = data?.has_web_access ?? 1;
const hasMobileAccess = data?.has_mobile_access ?? 1;

    return (
        <Card>
            <Card.Header className="pt-3 mb-2">
                <h4>
                    {data?.username}
                </h4>
            </Card.Header>
            <Card.Body className="py-0">
                <Row className='mb-3'>
                    <Col lg={4} className="ps-2 ps-lg-3 me-0 ms-auto">
                        {data.facility_id ? <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Facility Name:  </h6>
                            </div>
                        </Flex> : []}
                        {groupData ? <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Group Name: {groupData[0]?.key} </h6>
                            </div>
                        </Flex> : []}
                        {isFacilityStaff ? <div className="d-flex flex-column flex-sm-row gap-2 mt-3">
                            <AccessTile icon="globe" label="Web Access" enabled={hasWebAccess} />
                            <AccessTile icon="mobile" label="Mobile Access" enabled={hasMobileAccess} />
                        </div> : []}
                    </Col>

                    <Row className="col-12 mx-0 w-100 avatar-profile-sec">
                        <Avatar
                            size="auto"
                            className="avatar-profile col-1 mx-0 px-0"
                            src={avatar}
                            mediaClass="img-thumbnail shadow-sm"
                        />
                    </Row>
                </Row>
            </Card.Body>
        </Card>
    )
}

export default ViewFacilityStaffProfileHeader
